import { tokens } from './Lookup';
export function isNull(arg) {
    return arg === null;
}
export function allEmpty(t) {
    return isNull(t.field) && isNull(t.operator) && isNull(t.value);
}
export function onlyValue(t) {
    return isNull(t.field) && isNull(t.operator) && !isNull(t.value);
}
export function onlyField(t) {
    return !isNull(t.field) && isNull(t.operator) && isNull(t.value);
}
export function fieldAndOperator(t) {
    return !isNull(t.field) && !isNull(t.operator);
}
export function fieldOperatorAndNotValue(t) {
    return !isNull(t.field) && !isNull(t.operator) && isNull(t.value);
}
export function fieldOperatorAndValue(t) {
    return !isNull(t.field) && !isNull(t.operator) && !isNull(t.value);
}
export function isConjunction(x) {
    return x === tokens.AND || x === tokens.OR;
}
export function isSpace(x) {
    return x === tokens.SPACE;
}
